export default __webpack_public_path__ + "./images/sberSpasibo.d07a2aed.svg";